import { type BreadcrumbT } from '../components/CustomBreadcrumbs'
import type ROUTES from '../consts/paths'
import { type URLSearchParams } from 'url'

export interface CustomBreadcrumbT {
  title: string
  path: string
  isInScope?: boolean
}

export const prepareBreadCrumbs = (
  breadCrumbData: BreadcrumbT[],
  route: ROUTES,
  searchParams?: URLSearchParams,
  checkIsInScope: boolean = false
): CustomBreadcrumbT[] => {
  return (
    breadCrumbData?.map((data: BreadcrumbT) => ({
      title: data.title,
      path: `${route}/${data.id}?${searchParams?.toString()}`,
      isInScope: checkIsInScope ? data.isInScope : true
    }))

  )
}
